var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21252 9.66663H5.42216C4.03237 9.66663 2.89526 8.57913 2.89526 7.24996V4.83329C2.89526 3.50413 4.03237 2.41663 5.42216 2.41663H9.21252C10.6023 2.41663 11.7394 3.50413 11.7394 4.83329V7.24996C11.7394 8.57913 10.6023 9.66663 9.21252 9.66663Z",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6482 8.45833H22.0998C21.2659 8.45833 20.5837 7.80582 20.5837 7.00832V5.07501C20.5837 4.27751 21.2659 3.625 22.0998 3.625H26.6482C27.4821 3.625 28.1644 4.27751 28.1644 5.07501V7.00832C28.1644 7.80582 27.4821 8.45833 26.6482 8.45833Z",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6482 17.5208H22.0998C21.2659 17.5208 20.5837 16.8683 20.5837 16.0708V14.1375C20.5837 13.34 21.2659 12.6875 22.0998 12.6875H26.6482C27.4821 12.6875 28.1644 13.34 28.1644 14.1375V16.0708C28.1644 16.8683 27.4821 17.5208 26.6482 17.5208Z",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7395 6.04163H20.5837",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1615 6.04163V21.75C16.1615 23.0791 17.2986 24.1666 18.6884 24.1666H20.5836",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1615 15.1041H20.5836",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6482 26.5833H22.0998C21.2659 26.5833 20.5837 25.9308 20.5837 25.1333V23.2C20.5837 22.4025 21.2659 21.75 22.0998 21.75H26.6482C27.4821 21.75 28.1644 22.4025 28.1644 23.2V25.1333C28.1644 25.9308 27.4821 26.5833 26.6482 26.5833Z",
    stroke: "#48A5D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer7);
export default __webpack_public_path__ + "static/media/Layer7.891f3bb497df3a55f8cadfdabb8e1a4a.svg";
export { ForwardRef as ReactComponent };